import { connect } from 'react-redux'
import { compose, withHandlers, withStateHandlers } from 'recompose'
import { cancelEditBalance, createBalance } from 'src/actions/loan'
import {
  selectLoanSaving,
  selectEditableLoanUUID,
  selectEditableLoanBalance,
  selectEditableLoanEstimatedBalance,
  selectEditableLoanHomeID,
  selectEditableLoanAmount
} from 'src/store/selectors/home/loans'

const EditBalanceContainer = compose(
  connect(
    state => ({
      saving: selectLoanSaving(state),
      homeId: selectEditableLoanHomeID(state),
      uuid: selectEditableLoanUUID(state),
      value: selectEditableLoanBalance(state),
      estimatedValue: selectEditableLoanEstimatedBalance(state),
      loanAmount: selectEditableLoanAmount(state)
    }),
    dispatch => ({
      createBalance: (homeId, uuid, value) =>
        dispatch(createBalance({ homeId, uuid, value })),
      cancelEditBalance: () => dispatch(cancelEditBalance())
    })
  ),
  withStateHandlers(
    ({ estimatedValue, value = Math.round(estimatedValue) }) => ({ value }),
    { onChangeValue: () => ({ target: { value } }) => ({ value }) }
  ),
  withHandlers({
    onSubmit: ({ homeId, uuid, value, createBalance }) => event => {
      event.preventDefault()
      createBalance(homeId, uuid, value)
    },
    onCancel: ({ cancelEditBalance }) => () => cancelEditBalance()
  })
)

export default EditBalanceContainer
